webpackJsonp([263791100135453],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7 col-md-4 col-sm-4 about' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'bigger' },
	                    'Hi,'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'bigger' },
	                    'My name is Sandra Harrison and I am an Anthropologist offering 7 years\' qualitative research experience.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'bigger' },
	                    'Anthropology as a human science empowers me to understand subjective experience, gain insights into people\u2019s motivations and actions, and cutting through the clutter of taken \'for\' granted assumptions and conventional wisdom.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'bigger' },
	                    'I want to apply my anthropological analytical skills and ethnographic methods to find out what it means to be human in today\'s world and translate these findings into a positive service design experience.'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Anthropology has taught me how to:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'bigger' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'make use of my natural curiosity and pay close attention'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'ask the right questions'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'develop a reading to understand human behaviour, motivations, attitudes and frustrations'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'recognise and uncover patterns of cultural practice'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'be empathic and cultural aware for the research subjects and environment'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'make sense of my observations and communicate my moments of clarity in a structured way'
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 col-md-8 col-sm-8 about' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'My research expertise includes:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'The postal industry'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Prosthetic technology'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Body politics'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Travel phenomena'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Age-friendly communities and social media'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Family and home movies'
	                    )
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'My methods include:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Sensemaking and Abductive Reasoning'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Narratives and Storytelling Analysis'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Participative Observation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Qualitative Interview'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Ethnographic Listening'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'One-on-One User Testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Remote Testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Guerrilla Prototype Testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Card Sorting'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Treejack Testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Diary Study Research'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Survey'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Heuristic Evaluation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Literature Review'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Competitive Analysis'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Co-Design Workshop'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Success Criteria Workshop'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Qualitative phenomenology analysis'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Thick Description'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Narratives and Storytelling'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Research Diary'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Cultural probe: Iconographical-Iconological Image-Discourse Analysis'
	                    )
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null)
	            )
	        )
	    );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-63b9410970f7fb9b365a.js